/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { OTPPrompt } from "./OTPPrompt";

const OTPPromptContainer = ({
  visible,
  mobileNumber,
  onVerifyOtpClick,
  onResendOtpClick,
  errorMessage,
  otpFieldOnChange,
}) => {
  return (
    <OTPPrompt
      visible={visible}
      mobileNumber={mobileNumber}
      onVerifyOtpClick={onVerifyOtpClick}
      onResendOtpClick={onResendOtpClick}
      errorMessage={errorMessage}
      otpFieldOnChange={otpFieldOnChange}
    />
  );
};

export default OTPPromptContainer;
